module.exports = __webpack_public_path__ + "img/Millionaire-5.89cb745b.png";